import React from "react";
import PropTypes from "prop-types";
import Image from "../global/Image";
import SmartWidth from "../../utils/ImageWidthHandler";
import CTAs from "../global/Ctas";

/********************************
<Person />
/********************************
Version: 1
Created: 27 02 2025
Updated: 27 02 2025
Author: Richy Pears
/********************************
Returns a person
<Columns /> components

TODO: For some reason the xl:w-1/7
and higher numbers are not working/
registering
/********************************/

const Person = ({ columns, node }) => {
  if (!node) return null; // Escape hatch

  const imageWidth = SmartWidth(columns && columns, "width"); // This returns optimum widths for our images

  return (
    <div
      className={`flex flex-col p-6 shrink-0 grow-0 
      ${
        columns?.xs && columns?.xs !== "auto"
          ? ` w-1/${columns.xs} shrink-0`
          : ``
      }
      ${
        columns?.sm && columns?.sm !== "auto"
          ? ` sm:w-1/${columns.sm} sm:shrink-0`
          : ``
      }
      ${
        columns?.md && columns?.md !== "auto"
          ? ` md:w-1/${columns.md} md:shrink-0`
          : ``
      }
      ${
        columns?.lg && columns?.lg !== "auto"
          ? ` lg:w-1/${columns.lg} lg:shrink-0`
          : ``
      }
      ${
        columns?.xl && columns?.xl !== "auto"
          ? ` xl:w-1/${columns.xl} xl:shrink-0`
          : ``
      }
    `}
    >
      <div className="flex flex-col gap-3 items-center justify-center text-center">
        {node.image && (
          <Image
            aspect="1x1"
            src={node.image}
            sizes={imageWidth}
            className={`rounded-full w-full`}
          />
        )}
        <div>
          {node.name && <p className="m-0 text-xs font-bold">{node.name}</p>}
          {node.role && <p className="m-0 text-xs">{node.role}</p>}
          {node.ctas && (
            <CTAs
              ctas={node.ctas}
              layout="column"
              align="center"
              className="mt-3"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Person;

Person.defaultProps = {
  columns: null,
  node: null,
};

Person.propTypes = {
  columns: PropTypes.object,
  node: PropTypes.object,
};
